import { NavigationItem } from "./navigation.types";

export const navigations: NavigationItem[] = [
    {
        id: 'home',
        title: 'Accueil',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/home',
        authorized: ['User', 'Admin']
    },
    {
        id: 'data-settings',
        title: 'Paramètres de données',
        type: 'basic',
        icon: 'heroicons_outline:cog-6-tooth',
        link: '/data-settings/models',
        authorized: ['Admin']
    },
    {
        id: 'data-management',
        title: 'Gestion des données',
        type: 'aside',
        icon: 'feather:database',
        authorized: ['Admin'],
        children: [
            {
                id: 'separator',
                type: 'divider'
            },
            {
                id: 'ingestions',
                title: 'Importation des données',
                type: 'basic',
                icon: 'heroicons_outline:cloud-arrow-up',
                link: '/data-management/ingestions'
            },
            {
                id: 'ingestions-validation',
                title: 'Validation de l\'importation des données',
                type: 'basic',
                icon: 'heroicons_outline:check-badge',
                link: '/data-management/ingestions/validation',
                authorized: ['validate_ingestions']
            },
            {
                id: 'validation-documents',
                title: 'Validations des documents',
                type: 'basic',
                icon: 'heroicons_outline:check-badge',
                link: '/data-management/pending-validation',
                authorized: ['validate_reports']
            },
            {
                id: 'separator',
                type: 'divider'
            },
            {
                id: 'data-sets',
                title: 'Jeux de données',
                type: 'basic',
                icon: 'feather:database',
                link: '/data-management/datasets'
            },
            {
                id: 'data-playground',
                title: 'OLAP Playground',
                type: 'basic',
                icon: 'feather:airplay',
                link: '/data-management/playground'
            },
            {
                id: 'separator',
                type: 'divider'
            },
            {
                id: 'database-extractions',
                title: 'Extractions',
                type: 'basic',
                icon: 'heroicons_outline:circle-stack',
                link: '/data-management/database-extractions',
                authorized: ['Validate_export', 'SuperAdmin']
            }
        ]
    },
    {
        id: 'dashboard',
        title: 'Tableaux de bord',
        type: 'aside',
        icon: 'heroicons_outline:presentation-chart-line',
        authorized: ['Admin', 'User'],
        children: [
            {
                id: 'dashboard-types',
                title: 'Types des Tableaux de Bord',
                type: 'group',
            },
            {
                id: 'separator',
                type: 'divider'
            },

            {
                id: 'dashboard-std',
                title: 'Tableaux de bord standard',
                type: 'basic',
                icon: 'heroicons_outline:presentation-chart-line',
                link: '/data-management/dashboards/Standard',
                authorized: ['Admin', 'User']
            },
            {
                id: 'dashboard-map',
                title: 'Tableaux de bord Cartes',
                type: 'basic',
                icon: 'heroicons_outline:map',
                link: '/data-management/dashboards/Map',
                authorized: ['Admin', 'User']
            },
            {
                id: 'dashboard-benchmark',
                title: 'Tableaux de bord Benchmark',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar-square',
                link: '/data-management/dashboards/Benchmark',
                authorized: ['Admin', 'User']
            },
            {
                id: 'separator',
                type: 'divider'
            },
            {
                id: 'dashboard-create',
                title: 'Créer un tableau de bord',
                type: 'basic',
                icon: 'heroicons_solid:plus-circle',
                link: '/data-management/dashboard-builder',
                authorized: ['Admin', 'User']
            },
    
            {
                id: 'dashboard-templates',
                title: 'Modèles de Templates',
                type: 'basic',
                icon: 'dashboard_customize',
                link: '/data-management/dashboard-templates',
                authorized: ['Admin', 'User']
            }
        ]
    },
    {
        id: 'documents',
        title: 'Documents',
        type: 'basic',
        icon: 'heroicons_outline:document-duplicate',
        link: '/data-management/documents',
        authorized: ['Admin', 'User']
    },
    {
        id: 'graphics',
        title: 'Graphiques',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar-square',
        link: '/data-management/graphics',
        authorized: ['Admin', 'User']
    },
    // {
    //     id: 'graphic-comparator',
    //     title: 'Comparateur',
    //     type: 'basic',
    //     icon: 'compare',
    //     link: '/data-management/graphic-comparator',
    //     authorized: ['Admin', 'User']
    // },
    {
        id: 'parameters',
        title: 'Paramètres',
        type: 'aside',
        icon: 'heroicons_outline:wrench-screwdriver',
        authorized: ['Admin'],
        children: [
            {
                id: 'companies',
                title: 'Compagnies',
                type: 'basic',
                icon: 'heroicons_outline:building-office-2',
                link: '/user-management/companies'
            },
            {
                id: 'users',
                title: 'Utilisateurs',
                type: 'basic',
                icon: 'heroicons_outline:user',
                link: '/user-management/users',
                authorized: ['users']
            },
            {
                id: 'subscriptions',
                title: 'Abonnements',
                type: 'basic',
                icon: 'heroicons_outline:inbox-arrow-down',
                link: '/subscriptions',
                authorized: ['subscriptions']
            },
            {
                id: 'separtor',
                type: 'divider'
            },
            {
                id: 'localities',
                title: 'Pays et localités',
                type: 'basic',
                icon: 'heroicons_outline:map-pin',
                link: '/parameters/localities'
            },
            {
                id: 'domains',
                title: 'Domaines d\'activités',
                type: 'basic',
                icon: 'heroicons_outline:rectangle-group',
                link: '/parameters/company-domains'
            },
            {
                id: 'separtor',
                type: 'divider'
            },
            {
                id: 'tasks-manager',
                title: 'Gestion des tâches',
                type: 'basic',
                icon: 'heroicons_outline:cog-6-tooth',
                link: '/parameters/tasks-manager'
            },
            // {
            //     id: 'cube-manager',
            //     title: 'Gestion des cubes',
            //     type: 'basic',
            //     icon: 'heroicons_outline:cube',
            //     link: '/parameters/cube-manager'
            // },
            // {
            //     id: 'druid-manager',
            //     title: 'Gestion Druid',
            //     type: 'basic',
            //     icon: 'heroicons_outline:server-stack',
            //     link: '/parameters/druid-manager'
            // }
        ]
    }
];